import {
  // removeNullAttributes,
  // queryStringFromObject,
  authHeader,
  handleResponse,
  handleNoContentResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getGlobalRelease() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  // const queryObject = removeNullAttributes(queryParams);
  // const query = queryStringFromObject(queryObject);

  const endPoint = `/api/admin/v1/releases/fuses/global`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function addGlobalRelease(formData) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(formData),
  };

  const endPoint = `/api/admin/v1/releases/fuses/global`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleNoContentResponse)
    .then((data) => {
      return data;
    });
}

function editGlobalRelease(formData) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(formData),
  };

  const endPoint = `/api/admin/v1/releases/fuses/global`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleNoContentResponse)
    .then((data) => {
      return data;
    });
}

export const globalReleaseService = {
  getGlobalRelease,
  addGlobalRelease,
  editGlobalRelease,
};
